module.exports = __webpack_public_path__ + "img/core-connect-old.7019e8e0.jpg";